import { useMutation, useQuery } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import usePages from "../../common/hooks/pages/usePages";
import Pages from "../components/Pages";
import ApiValidate from "../../common/components/ApiValidate";
import { useCallback, useState } from "react";
import { getDefaultAction } from "../../common/helpers/common";
import { useApp } from "../../common/contexts/AppContext";

function PagesContainer() {
  const { pages, setPages } = useApp();

  const [action, setAction] = useState(getDefaultAction());

  const onClose = useCallback(() => {
    setAction(getDefaultAction());
  }, []);

  const { toast } = usePopup();

  const { getPages, deletePage } = usePages();

  const { isOwner } = useApp();

  const { isError, isLoading, refetch } = useQuery({
    retry: false,
    queryKey: "getPages",
    queryFn: getPages,
    onSuccess: (res) => {
      const { pages } = res?.data || {};

      setPages(pages);
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting pages!";
      toast(message, "error");
    },
  });

  const { mutate: deletePageMutate, isLoading: isDeleting } = useMutation({
    mutationFn: deletePage,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      refetch();

      onClose();

      toast(message, "success");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while deleting page!";

      toast(message, "error");
    },
  });

  return (
    <ApiValidate isLoading={isLoading} isError={isError}>
      <Pages
        action={action}
        setAction={setAction}
        onClose={onClose}
        pages={pages}
        refetch={refetch}
        isOwner={isOwner}
        onDelete={(pageId) => deletePageMutate(pageId)}
        isDeleting={isDeleting}
      />
    </ApiValidate>
  );
}

export default PagesContainer;
